import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AddApplicationComponent } from './components/add-application/add-application.component';
import { ApplicationsComponent } from './components/applications/applications.component';
import { AttendeesComponent } from './components/attendees/attendees.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { CoverComponent } from './components/cover/cover.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { LoginComponent } from './components/login/login.component';
import { MeetupsComponent } from './components/meetups/meetups.component';
import { MembersComponent } from './components/members/members.component';
import { MoneyPerApplicationComponent } from './components/money-per-application/money-per-application.component';
import { MoneyPerMeetupComponent } from './components/money-per-meetup/money-per-meetup.component';
import { NavigationComponent } from './components/navigation/navigation.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { ReviewApplicationComponent } from './components/review-application/review-application.component';
import { UpdateApplicationComponent } from './components/update-application/update-application.component';
import { UsersComponent } from './components/users/users.component';
import { WeGotYourApplicationComponent } from './components/we-got-your-application/we-got-your-application.component';
import { AuthGuard } from './guards/auth.guard';

const routes: Routes = [
	{ path: '', redirectTo: '/add-application', pathMatch: 'full' },
	{ path: 'cover', component: CoverComponent },
	{ path: 'login', component: LoginComponent },
	{ path: 'reset-password', component: ResetPasswordComponent },
	{ path: 'change-password', component: ChangePasswordComponent },
	{
		path: '', component: NavigationComponent,
		children: [
			{ path: 'add-application', component: AddApplicationComponent },
			{ path: 'we-got-your-application', component: WeGotYourApplicationComponent },
			// { path: 'review-application/:key', component: ReviewApplicationComponent },
			{ path: 'review-application/:key', component: UpdateApplicationComponent },
			{ path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard] },
			{ path: 'meetups', component: MeetupsComponent, canActivate: [AuthGuard] },
			{ path: 'applications', component: ApplicationsComponent, canActivate: [AuthGuard] },
			{ path: 'attendees', component: AttendeesComponent, canActivate: [AuthGuard] },
			{ path: 'members', component: MembersComponent, canActivate: [AuthGuard] },
			{ path: 'users', component: UsersComponent, canActivate: [AuthGuard] },
			{ path: 'money-per-application', component: MoneyPerApplicationComponent, canActivate: [AuthGuard] },
			{ path: 'money-per-meetup', component: MoneyPerMeetupComponent, canActivate: [AuthGuard] },
		]
	}
];

@NgModule({
	imports: [
		CommonModule,
		RouterModule.forRoot(routes)
	],
	exports: [
		RouterModule
	],
	declarations: []
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// C:/Source/Ecim/Ecim.Web/src/app/app-routing.module.ts